export default __webpack_public_path__ + "static/media/taka.f8d0404f.png";